import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import withStyles from '@material-ui/core/styles/withStyles';

import Person from '@material-ui/icons/Person';
import Lock from '@material-ui/icons/Lock';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import Notifier, { openSnackbar } from '../components/notifier';

import api from '../api/backend'

import logo from '../assets/img/logo.png'

import ReactGA from 'react-ga';

const styles = theme => ({
    layout: {
        position: 'relative',
        minHeight: '100vh',
        width: '100%',
        paddingTop: 80,
        paddingBottom: theme.spacing.unit * 4,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        overflow: 'hidden',
        background: 'linear-gradient(135deg, #f8982b 0%, #ffb56b 35%, #ffd6a5 65%, #b8a4d4 100%)',
        backgroundSize: '400% 400%',
        animation: 'gradientDrift 25s ease-in-out infinite alternate',
    },
    blobLayer: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
        zIndex: 0,
    },
    blob: {
        position: 'absolute',
        width: 480,
        height: 480,
        borderRadius: '50%',
        filter: 'blur(80px)',
        WebkitFilter: 'blur(80px)',
        opacity: 0.45,
        willChange: 'transform',
    },
    blob1: {
        background: '#ffb56b',
        top: '-10%',
        left: '-10%',
        animation: 'blobDrift1 40s ease-in-out infinite alternate',
    },
    blob2: {
        background: '#b8a4d4',
        top: '40%',
        right: '-15%',
        animation: 'blobDrift2 50s ease-in-out infinite alternate',
    },
    blob3: {
        background: '#ffd6a5',
        bottom: '-15%',
        left: '20%',
        animation: 'blobDrift3 60s ease-in-out infinite alternate',
    },
    paper: {
        position: 'relative',
        zIndex: 1,
        width: '100%',
        maxWidth: 400,
        marginTop: theme.spacing.unit * 4,
        marginLeft: theme.spacing.unit * 2,
        marginRight: theme.spacing.unit * 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 4}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
        backgroundColor: 'rgba(255, 255, 255, 0.78)',
        backdropFilter: 'blur(14px)',
        WebkitBackdropFilter: 'blur(14px)',
        border: '1px solid rgba(255, 255, 255, 0.5)',
        borderRadius: 16,
        boxShadow: '0 20px 60px rgba(31, 38, 135, 0.15), 0 4px 16px rgba(31, 38, 135, 0.08)',
    },
    logo: {
        width: 72,
        height: 72,
        objectFit: 'contain',
        marginBottom: theme.spacing.unit,
    },
    heading: {
        padding: `${theme.spacing.unit}px 0 ${theme.spacing.unit * 2}px`,
        textAlign: 'center',
    },
    form: {
        width: '100%',
        marginTop: theme.spacing.unit,
    },
    field: {
        marginTop: theme.spacing.unit * 2,
    },
    submit: {
        marginTop: theme.spacing.unit * 3,
        transition: 'transform 0.15s ease-out, box-shadow 0.15s ease-out',
        '&:hover': {
            transform: 'translateY(-1px)',
            boxShadow: '0 6px 18px rgba(248, 152, 43, 0.35)',
        },
    },
    secondary: {
        marginTop: theme.spacing.unit,
    },
    '@keyframes gradientDrift': {
        '0%': { backgroundPosition: '0% 50%' },
        '100%': { backgroundPosition: '100% 50%' },
    },
    '@keyframes blobDrift1': {
        '0%': { transform: 'translate3d(0, 0, 0) scale(1)' },
        '100%': { transform: 'translate3d(80px, 60px, 0) scale(1.15)' },
    },
    '@keyframes blobDrift2': {
        '0%': { transform: 'translate3d(0, 0, 0) scale(1)' },
        '100%': { transform: 'translate3d(-100px, -80px, 0) scale(1.1)' },
    },
    '@keyframes blobDrift3': {
        '0%': { transform: 'translate3d(0, 0, 0) scale(1)' },
        '100%': { transform: 'translate3d(60px, -70px, 0) scale(1.2)' },
    },
    '@media (prefers-reduced-motion: reduce)': {
        layout: { animation: 'none' },
        blob1: { animation: 'none' },
        blob2: { animation: 'none' },
        blob3: { animation: 'none' },
    },
});

class SignIn extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { email: '', password: '', showPassword: false, loading: false }
    }

    componentDidMount() {
        ReactGA.initialize('UA-141674580-1');
        ReactGA.pageview('SignIn');
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const { email, password } = this.state
        console.log('login with', email, password)
        ReactGA.event({
            category: 'Login',
            action: `Login with [${email}]`
          })
        this.setState({ loading: true })
        api.login(email, password).then(([response, json]) => {
            this.setState({ loading: false })
            if (response.status === 200) {
                console.log(json)
                sessionStorage.setItem('user', JSON.stringify(json))
                this.props.history.push('/')
            } else if(response.status === 409) {
                openSnackbar({ message: 'กรุณารอการอนุมัติจากทางสถาบัน' })
            } else {
                console.error('login ไม่สำเร็จกรุณาลองใหม่อีกครั้ง')
                openSnackbar({ message: 'login ไม่สำเร็จกรุณาลองใหม่อีกครั้ง' })
            }
        }).catch(() => {
            this.setState({ loading: false })
            console.error('login ไม่สำเร็จกรุณาลองใหม่อีกครั้ง')
            openSnackbar({ message: 'login ไม่สำเร็จกรุณาลองใหม่อีกครั้ง' })
        })
    }

    toggleShowPassword = () => {
        this.setState(prev => ({ showPassword: !prev.showPassword }))
    }

    render() {
        const { classes } = this.props
        const { showPassword, loading } = this.state
        return (
            <React.Fragment>
                <CssBaseline />
                <main className={classes.layout}>
                    <div className={classes.blobLayer} aria-hidden="true">
                        <div className={`${classes.blob} ${classes.blob1}`} />
                        <div className={`${classes.blob} ${classes.blob2}`} />
                        <div className={`${classes.blob} ${classes.blob3}`} />
                    </div>
                    <Notifier />
                    <Paper className={classes.paper} elevation={0}>
                        <img src={logo} alt="ติวเตอร์ครูก้อ" className={classes.logo} />
                        <Typography variant="display2" className={classes.heading}>ติวเตอร์ครูก้อ</Typography>
                        <form className={classes.form} onSubmit={this.handleSubmit}>
                            <TextField
                                id="email"
                                name="email"
                                variant="outlined"
                                label="Username / Email"
                                autoComplete="email"
                                autoFocus
                                fullWidth
                                required
                                className={classes.field}
                                value={this.state.email}
                                onChange={(e) => { this.setState({ email: e.target.value }) }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Person color="action" />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <TextField
                                id="password"
                                name="password"
                                variant="outlined"
                                label="Password"
                                type={showPassword ? 'text' : 'password'}
                                autoComplete="current-password"
                                fullWidth
                                required
                                className={classes.field}
                                value={this.state.password}
                                onChange={(e) => { this.setState({ password: e.target.value }) }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Lock color="action" />
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="Toggle password visibility"
                                                onClick={this.toggleShowPassword}
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="raised"
                                color="primary"
                                className={classes.submit}
                                disabled={loading}
                            >
                                {loading ? <CircularProgress size={20} color="inherit" /> : 'ลงชื่อเข้าใช้'}
                            </Button>
                            <Button
                                fullWidth
                                variant="text"
                                color="primary"
                                className={classes.secondary}
                                onClick={() => {
                                    this.props.history.push('/register')
                                }}
                            >
                                ลงทะเบียนเข้าใช้งาน
                            </Button>
                        </form>
                    </Paper>
                </main>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(SignIn);
